import confetti from 'canvas-confetti'

export function fireCosmeticRewardConfetti() {
  if (
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return
  }
  const duration = 2.8 * 1000
  const animationEnd = Date.now() + duration
  const defaults = {
    startVelocity: 32,
    spread: 360,
    ticks: 55,
    zIndex: 9999,
    colors: ['#FFE400', '#FFBD00', '#E89400', '#a25afd', '#26ccff', '#88ff5a', '#ff5e7e']
  }

  const randomInRange = (min: number, max: number) =>
    Math.random() * (max - min) + min

  const interval = window.setInterval(() => {
    const timeLeft = animationEnd - Date.now()
    if (timeLeft <= 0) {
      window.clearInterval(interval)
      return
    }
    const particleCount = 42 * (timeLeft / duration)
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.12, 0.32), y: randomInRange(0.15, 0.45) }
    })
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.68, 0.88), y: randomInRange(0.15, 0.45) }
    })
  }, 220)

  const starDefaults = {
    spread: 360,
    ticks: 48,
    gravity: 0.45,
    decay: 0.94,
    startVelocity: 28,
    colors: ['#FFE400', '#FFBD00', '#FDFFB8', '#fcff42'],
    zIndex: 9999
  }
  confetti({
    ...starDefaults,
    particleCount: 45,
    scalar: 1.1,
    shapes: ['star'],
    origin: { x: 0.5, y: 0.42 }
  })
  window.setTimeout(() => {
    confetti({
      ...starDefaults,
      particleCount: 28,
      scalar: 0.85,
      shapes: ['circle'],
      origin: { x: 0.5, y: 0.38 }
    })
  }, 120)
}
